<mat-icon matTooltip="{{ 'Common.Filters.FilterGuid' | translate }}" [matMenuTriggerFor]="menu">filter_alt</mat-icon>

<mat-menu #menu="matMenu">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <form [formGroup]="filterForm" (click)="$event.stopPropagation();">
          <mat-form-field>
            <mat-label>{{ 'Common.Filters.FilterType' | translate }}</mat-label>
            <mat-select [formControl]="filterTypeControl" [value]="filterTypeControl"
              (selectionChange)="onFilterChange($event)">
              @for (option of filterOptions; track option) {
                <mat-option [value]="option.value">
                  {{ option.translationKey | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    </div>

    @if (this.currentFilter.value !== enumContainsFilter) {
      <div class="row">
        <div class="col-12">
          <form [formGroup]="enumForm" (click)="$event.stopPropagation();">
            <mat-form-field>
              @if (filterSelectText) {
                <mat-label>{{ filterSelectText | translate }}</mat-label>
              }
              @if (!filterSelectText) {
                <mat-label>{{ 'Common.Filters.ChooseValue' | translate }}
                </mat-label>
              }
              <mat-select [formControl]="enumControl">
                @for (option of options; track option) {
                  <mat-option [value]="option.id">
                    {{option.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </form>
        </div>
      </div>
    } @else {
      <div class="row">
        <div class="col-12">
          <form [formGroup]="multipleEnumForm" (click)="$event.stopPropagation();">
            <mat-form-field>
              @if (filterSelectText) {
                <mat-label>{{ filterSelectText | translate }}</mat-label>
              }
              @if (!filterSelectText) {
                <mat-label>{{ 'Common.Filters.ChooseValue' | translate }}
                </mat-label>
              }
              <mat-select [formControl]="multipleEnumControl" multiple>
                @for (option of options; track option) {
                  <mat-option [value]="option.id">{{option.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </form>
        </div>
      </div>
    }

    <div class="row">
      <div class="col" style="display: flex; justify-content: flex-end;">
        <mat-icon matTooltip="{{ 'Common.Filters.Cancel' | translate }}" class="cursor-pointer"
          color="primary" (click)="onCancel()">
          clear
        </mat-icon>
        <mat-icon matTooltip="{{ 'Common.Filters.RunFilter' | translate }}" class="cursor-pointer"
          color="primary" (click)="onSubmit($event)">
          check
        </mat-icon>
        @if (this.currentValue | async) {
          <mat-icon matTooltip="{{ 'Common.Filters.Clear' | translate }}" class="cursor-pointer" color="primary"
            (click)="onClear()">
            delete
          </mat-icon>
        }
      </div>
    </div>
  </div>
</mat-menu>
